import { FC } from 'react';

const DeleteAccountPage: FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 bg-gray-50">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary-100 mb-4">
            Delete Your Account
          </h1>
          <p className="text-lg text-gray-600">
            Follow these steps to permanently delete your Golfers Honours
            account.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Instructions
            </h2>
            <ol className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-white font-semibold mr-3 flex-shrink-0">
                  1
                </span>
                <span className="pt-1">
                  Log in to the Golfers Honours mobile application
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-white font-semibold mr-3 flex-shrink-0">
                  2
                </span>
                <span className="pt-1">
                  Select the <strong>Account</strong> tab in the navigation menu
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-white font-semibold mr-3 flex-shrink-0">
                  3
                </span>
                <span className="pt-1">
                  Scroll to the bottom of the Account page
                </span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-white font-semibold mr-3 flex-shrink-0">
                  4
                </span>
                <span className="pt-1">
                  Select the <strong>Delete Account</strong> option
                </span>
              </li>
            </ol>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-red-800 mb-2">
              Important Notice
            </h3>
            <p className="text-red-700">
              Deleting your account is permanent and cannot be undone. All of
              your data will be permanently removed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
